import * as React from 'react'
import { useHits } from 'react-instantsearch-hooks-web'
import { Hit, BaseHit } from 'instantsearch.js'

import styled from 'styled-components'
import { FbEnrichedUser } from '../../../interfaces/User'
import { fbEnrichUsersFromIds } from '../../../data/FirebaseEnrich'
import UserHitItem from './UserHitItem'
import { PublicKey } from '@solana/web3.js'
import { captureException } from '@sentry/nextjs'

const OuterDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
`

const Title = styled.div`
  font-weight: 700;
  font-size: 24px;
  color: white;
`

interface Props {
  query: string
  setNoResults: (noResults: boolean) => void
  onClick: () => void
}

const UserHits = ({ setNoResults, query, onClick }: Props): JSX.Element => {
  const { hits } = useHits()
  const [users, setUsers] = React.useState<FbEnrichedUser[]>([])
  const [addresses, setAddresses] = React.useState<FbEnrichedUser[]>([])

  const transform = async (items: Hit<BaseHit>[]): Promise<void> => {
    const userIds: string[] = items.map((item) => item.objectID).filter(Boolean) as string[]
    const users = await fbEnrichUsersFromIds(userIds)
    setUsers(users)
  }

  React.useEffect(() => {
    transform(hits)
  }, [hits])

  React.useEffect(() => {
    if (users.length === 0) {
      setNoResults(true)
    } else {
      setNoResults(false)
    }
  }, [users])

  const searchAddress = async (query: string): Promise<void> => {
    try {
      const publicKey = new PublicKey(query)
      if (PublicKey.isOnCurve(publicKey.toBuffer())) {
        const newUsers = await fbEnrichUsersFromIds([query])
        setAddresses(newUsers)
        setNoResults(false)
      }
    } catch (e) {
      setAddresses([])
      console.log('Not a valid address')
      captureException(e)
    }
  }

  React.useEffect(() => {
    searchAddress(query)
  }, [query])

  if ((users.length === 0 || hits.length === 0) && addresses.length === 0) {
    return <></>
  }

  return (
    <OuterDiv>
      <Title>PEOPLE</Title>
      {users.map((user, i) => {
        return <UserHitItem key={`user-hit-item-${i}`} user={user} onClick={onClick} />
      })}
      {addresses.map((user, i) => {
        return <UserHitItem key={`user-hit-item-${i}`} user={user} onClick={onClick} />
      })}
    </OuterDiv>
  )
}

export default UserHits
